"use client";

import { useState, useEffect } from "react";
import EnrollmentForm from "../components/enrollment/EnrollmentForm";
import api from "../services/api"; // Adjust path as needed
import { toast } from "react-toastify";

const EnrollmentPage = () => {
  const [courses, setCourses] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch courses on component mount
  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const response = await api.get("/courses");
        const coursesData = response.data.data || [];
        setCourses(coursesData);
      } catch (error) {
        console.error("Error fetching courses:", error);
        toast.error("Failed to load courses");
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [refreshKey]); // Refresh when enrollment succeeds

  // Handle course selection from dropdown
  const handleCourseChange = (e) => {
    setSelectedCourseId(e.target.value);
  };

  // Find the selected course object based on ID
  const selectedCourse = courses.find(
    (course) => course._id === selectedCourseId
  );

  return (
    <div className="max-w-4xl p-6 mx-auto enrollment-page">
      <h1 className="mb-6 text-3xl font-bold text-gray-800">
        Student Enrollment Management
      </h1>

      <EnrollmentForm
        onEnrollmentSuccess={() => setRefreshKey((prev) => prev + 1)}
      />

      <div className="mt-8">
        <div className="mb-4">
          <label className="block mb-2 font-medium text-gray-700">
            Select Course to View Enrollments:
          </label>
          {loading ? (
            <div className="py-6 text-xl text-center text-gray-500 loading-spinner">
              <div className="w-12 h-12 mx-auto border-b-4 border-indigo-600 rounded-full animate-spin"></div>
              <p className="mt-4 text-lg text-gray-600">Loading course...</p>
            </div>
          ) : (
            <select
              value={selectedCourseId}
              onChange={handleCourseChange}
              className="w-full p-2 text-gray-800 bg-white border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">-- Select a course --</option>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <option key={course._id} value={course._id}>
                    {course.name}
                  </option>
                ))
              ) : (
                <option disabled>No courses available</option>
              )}
            </select>
          )}
        </div>

        {/* Display enrolled students */}
        {selectedCourseId && selectedCourse ? (
          <div className="p-6 mt-6 bg-white rounded-lg shadow-lg enrolled-students">
            <h2 className="mb-4 text-xl font-semibold text-gray-800">
              Students Enrolled in {selectedCourse.name}
            </h2>
            {selectedCourse.students.length > 0 ? (
              <ul className="pl-5 text-gray-700 list-disc">
                {selectedCourse.students.map((student) => (
                  <li key={student._id} className="mb-2">
                    {student.firstName} {student.lastName}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-gray-500">
                No students enrolled in this course.
              </p>
            )}
          </div>
        ) : selectedCourseId === "" && !loading ? (
          <p className="mt-4 text-gray-500">
            Please select a course to view enrolled students.
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default EnrollmentPage;
